/**
 * The customer a Search Console connect was started for.
 *
 * Pinned in sessionStorage at the moment the user clicks Connect rather than read from
 * the workspace context on return: the OAuth round trip is a full-page redirect, and
 * switching the selected customer in another tab in the meantime would otherwise
 * attach the grant to whichever customer happens to be selected when Google comes back.
 */
const GSC_OAUTH_CUSTOMER_ID = "gsc_oauth_customer_id";

export function rememberGscOAuthCustomerId(customerId: string): void {
  try {
    sessionStorage.setItem(GSC_OAUTH_CUSTOMER_ID, customerId);
  } catch {
    // sessionStorage unavailable (private mode) — the callback falls back to the
    // currently selected customer.
  }
}

export function readGscOAuthCustomerId(): string | undefined {
  try {
    return sessionStorage.getItem(GSC_OAUTH_CUSTOMER_ID) || undefined;
  } catch {
    return undefined;
  }
}

export function clearGscOAuthCustomerId(): void {
  try {
    sessionStorage.removeItem(GSC_OAUTH_CUSTOMER_ID);
  } catch {
    /* ignore */
  }
}
